import { apiClient } from '~/shared/api/data-ingestion-api'

export function fetchDocumentPDF(documentKey: string) {
  return apiClient.getDocumentPdfUrlDocumentsKeyPdfGet({
    path: {
      key: documentKey,
    },
  })
}
